import React, { useState } from "react";
import style from "./index.module.css";
import mail from "../../../Assets/mail.svg";
import PasswordIcon from "../../../Assets/PasswordIcon.svg";
import closeeye from "../../../Assets/closeeye.svg";
import eye from "../../../Assets/eye.svg";
import profile from "../../../Assets/profile.svg";
import edit from "../../../Assets/edit.svg";
import BackIcon from "../../../Assets/BackIcon.svg";
// import PasswordIcon from '../../../Assets/PasswordIcon.svg';
import * as api from "../../../services/api";

import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { background } from "@chakra-ui/react";

const ChangePassword = () => {
  const [passwordType, setPasswordType] = useState(false);
  const [creatPasswordType, setcreatPasswordType] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);
  const [input, setInput] = useState({
    oldpassword: "",
    newpassword: "",
    confirmpassword: "",
  });
  const [formData, setFormData] = useState([]);
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInput({ ...input, [name]: value });
  };

  const togglePassword = () => {
    setPasswordType(!passwordType);
  };
  const togglePassword1 = () => {
    setcreatPasswordType(!creatPasswordType);
  };
  const toggleConfirm = () => {
    setConfirmPassword(!confirmPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      input.oldpassword &&
      input.newpassword &&
      input.confirmpassword &&
      input.newpassword === input.confirmpassword
    ) {
      // let newdata = { ...input, id: new Date().getTime().toString() };
      // setFormData([...formData, newdata]);
      try {
        const response = await api.changePassword(
          input.oldpassword,
          input.newpassword
        );
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Password changed successfully",
            timer: 1300,
          });
          navigate(-1, { replace: true });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: error?.response?.data?.message,
          timer: 5000,
        });
      }
    } else if (input.newpassword !== input.confirmpassword) {
      // alert('Passwords do not match!');
      Swal.fire({
        icon: "error",
        title: "Passwords do not match!",
        timer: 2000,
      });
    } else {
      // alert('please fill data');
      Swal.fire({
        icon: "warning",
        title: "Please fill data!",
        timer: 2000,
      });
    }
    setInput({
      oldpassword: "",
      newpassword: "",
      confirmpassword: "",
    });
  };

  const navigate = useNavigate();

  return (
    <div className={style.container}>
      <div className={style.profilecont}>
        <div className={style.EditTxt}>
          <div
            onClick={() => navigate(-1, { replace: true })}
            className={style.backIcon}
          >
            <img src={BackIcon} alt="" />
          </div>
          <div className={style.changepwrd}>Change password</div>
        </div>
        {/* <div className={style.changepwrd}>Change Password</div> */}
      </div>
      <form className={style.formContainer} onSubmit={handleSubmit}>
        <div className={style.iconInput}>
          <div className={style.passwordEyeIcon}>
            <div>
              <img src={PasswordIcon} alt="PasswordIcon" />
            </div>
            <input
              type={!passwordType ? "password" : "text"}
              name="oldpassword"
              placeholder="Old Password"
              value={input.oldpassword}
              onChange={handleChange}
              style={{ fontweight: "400", fontfamily: "Roboto" }}
              autoComplete="off"
            />
            <div>
              <img
                src={!passwordType ? closeeye : eye}
                alt="PasswordIcon"
                onClick={togglePassword}
                className={style.eyeIcon}
                style={
                  passwordType
                    ? { cursor: "pointer", width: "100%" }
                    : { cursor: "pointer", width: "100%", height: "90%" }
                }
              />
            </div>
          </div>
        </div>
        <div className={style.iconInput}>
          <div className={style.passwordEyeIcon}>
            <div>
              <img src={PasswordIcon} alt="PasswordIcon" />
            </div>
            <input
              type={!creatPasswordType ? "password" : "text"}
              name="newpassword"
              placeholder="New Password"
              value={input.newpassword}
              onChange={handleChange}
              autoComplete="off"
            />
            <div className={style.eyeIcon}>
              <img
                src={!creatPasswordType ? closeeye : eye}
                alt="PasswordIcon"
                onClick={togglePassword1}
                style={
                  passwordType
                    ? { cursor: "pointer", width: "100%", height: "90%" }
                    : { cursor: "pointer", width: "100%" }
                }
              />
            </div>
          </div>
        </div>
        <div className={style.iconInput}>
          {/* <img src={mail} alt='emailIcon' /> */}
          <div>
            <img src={PasswordIcon} alt="PasswordIcon" />
          </div>
          <input
            type={!confirmPassword ? "password" : "text"}
            placeholder="Confirm Password"
            name="confirmpassword"
            value={input.confirmpassword}
            onChange={handleChange}
            autoComplete="off"
          />
          <div>
            <img
              src={!confirmPassword ? closeeye : eye}
              alt="PasswordIcon"
              className={style.eyeIcon}
              onClick={toggleConfirm}
              style={
                passwordType
                  ? { cursor: "pointer", width: "100%", height: "100%" }
                  : { cursor: "pointer", width: "100%", height: "100%" }
              }
            />
          </div>
        </div>
        <div className={style.loginBtn}>
          <button style={{ background: "#6C56FB", color: "#ffff" }}>
            Change
          </button>
          <button
            type="button"
            onClick={() => navigate(-1, { replace: true })}
            className={style.discardbtn}
          >
            Discard
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
